/** @file Client setup snippets for one token (Claude Code, Codex, env lines), each with a copy button. */
import type { CatalogKey, Translate } from '@pose2d/i18n/types';
import { useState } from 'react';
import { clientConfigs, type ClientConfig } from './clientConfigs';

/** Props of ClientSetup; `secret` is null for an existing token (the env lines get a placeholder). */
export interface ClientSetupProps {
  t: Translate;
  origin: string;
  name: string;
  secret: string | null;
  copy: (text: string) => Promise<void>;
}

const TITLES: Record<ClientConfig['id'], CatalogKey> = { claudeCode: 'tokens.configClaudeCode', codex: 'tokens.configCodex', env: 'tokens.configEnv' };

/** The secret-once warning shows only when a secret is given. */
export function ClientSetup({ t, origin, name, secret, copy }: ClientSetupProps) {
  const [copied, setCopied] = useState<string | null>(null);
  return (
    <div className="client-setup">
      {secret === null ? null : <p className="shell-hint">{t('tokens.secretOnce')}</p>}
      {clientConfigs(origin, name, secret ?? t('tokens.secretPlaceholder')).map((config) => (
        <figure key={config.id}>
          <figcaption>{t(TITLES[config.id])}</figcaption>
          <pre>{config.text}</pre>
          <button type="button" onClick={() => { copy(config.text).then(() => { setCopied(config.id); }, () => { setCopied(null); }); }}>
            {t(copied === config.id ? 'tokens.copied' : 'tokens.copy')}
          </button>
        </figure>
      ))}
    </div>
  );
}
